import { SWFontFaceResourceInfo } from "./SWFontFaceResource";
import { SWSnippetResourceInfo } from "./SWSnippetResource";
import { SWTextResourceInfo } from "./SWTextResource";
export const ResourceMap = {
    text: SWTextResourceInfo,
    font_face: SWFontFaceResourceInfo,
    snippet: SWSnippetResourceInfo
};
